import automaquillaje from "../assets/Servicios/taller-de-automaquillaje.png"
import maquillajeeditorial from "../assets/Servicios/maquillaje-editorial.png"
import extensionesdepestañas from "../assets/Servicios/extensiones-de-pestañas.png"
import maquillajesocial from "../assets/Servicios/maquillaje-social.png"
import carrerademaquillajesocialinicial from "../assets/Servicios/carrerademaquillajesocialinicial.png"

const Services = [
    {
        image: automaquillaje,
        title: "Taller de automaquillaje",
        description: "Aprende a ser tu propia maquilladora para todos los dias. Conoce como preparar tu piel y mucho màs.",
        list1: "Incluye materiales y herramientas para las clase",
        list2: "Duracion 3 hora aprox aprox ",
        list3: "Requisito ser mayor de 15 años"
    },
    {
        image: maquillajesocial,
        title: "MAQUILLAJE SOCIAL",
        description: "Servicio de Maquillaje personalizado a prueba de agua, hipoalergènico y de larga duraciòn para eventos",
        list1: "Requisito asistir desmaquillados el dia del servicio",
        list2: "Duracion 1hs aproximandamente",
        list3: "Incluye 5 (cinco) pestañas grupales por ojo"
    },
    {
        image: carrerademaquillajesocialinicial,
        title: "CARRERA DE MAQUILLAJE SOCIAL INICIAL",
        description: "Conoceras lo necesario para iniciar en el mundo del Makeup y asi poder iniciar tu carrera habiendo estudiado en MUA",
        list1: "Incluye apuntes y temario",
        list2: "Duracion 3 meses (3hs por clase)",
        list3: "Reserva del 50% del la cuota"
    },
    {
        image: extensionesdepestañas,
        title: "extensiones Pestañas",
        description: "Realza tu mirada con volumen clásico, pelo x pelo, o dale súper volumen con la técnica más pedida: volumen ruso.",
        list1: "Productos de primera línea",
        list2: "Pestañas full beauty 24/7. Olvidate del rimel",
        list3: "Se pueden agregar pestañas de color"
    },
    {
        image: maquillajeeditorial,
        title: "Maquillaje EDitorial",
        description: "Servicio de maquillaje para fotografía, lucí tus book de fotos para actores, quince, novias, campañas fotográficas, modelos y mas",
        list1: "Pieles sin efecto flashback",
        list2: "Creamos rostros con dimensiones",
        list3: "Se respetan todas las normas de bioseguridad"
    }
]

export default Services